import {
	useLocation,
	useNavigate,
	useSearchParams as useRouterSearchParams,
} from "react-router-dom";

export function usePathname(): string {
	return useLocation().pathname;
}

export function useSearchParams(): URLSearchParams {
	const [params] = useRouterSearchParams();
	return params;
}

export function useRouter(): Readonly<{
	push: (href: string) => void;
	replace: (href: string) => void;
	back: () => void;
	forward: () => void;
	refresh: () => void;
	prefetch: (_href: string) => Promise<void>;
}> {
	const navigate = useNavigate();
	return {
		push: (href) => navigate(href),
		replace: (href) => navigate(href, { replace: true }),
		back: () => navigate(-1),
		forward: () => navigate(1),
		refresh: () => window.location.reload(),
		prefetch: async () => undefined,
	};
}

export function redirect(href: string): never {
	window.location.replace(href);
	throw new Error(`Redirecting to ${href}`);
}

export function notFound(): never {
	throw new Response("Not Found", { status: 404 });
}
